"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var BannerTextLeft = function (_a) {
    var title = _a.title, background = _a.background, backgroundMobile = _a.backgroundMobile;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: Object.keys(breakpoints).length > 0 && background
            ? {
                backgroundImage: "url(".concat(breakpoints.mobile ? backgroundMobile : background, ")"),
            }
            : {} },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bannerContent }, title && (react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
            react_1.default.createElement("h1", null, title))))));
};
exports.default = BannerTextLeft;
